import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ServiceWorkerModule } from "@angular/service-worker";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { NgBusyModule, BusyConfig } from "ng-busy";
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';

import { AppComponent } from "./app.component";
import { AuthNRoutingModule } from "./auth-n-routing/auth-n-routing.module";
import { PageNotFoundModule } from "./pages/page-not-found/page-not-found.module";
import { DashboardModule } from "./pages/dashboard/dashboard.module";
import { LoginModule } from "./pages/login/login.module";

import { AuthService } from "./auth-n-routing/auth-service.service";
import { VehiclesHandlerService } from "./api-handlers/vehicles-handler.service";
import { RefillsHandlerService } from "./api-handlers/refills-handler.service";
import { DateHandlerService } from "./commons/date-handler.service";
import { SnackBarHandlerService } from "./commons/snack-bar-handler.service";
import { ParksHandlerService } from "./api-handlers/parks-handler.service";
import { TravelsHandlerService } from "./api-handlers/travels-handler.service";
import { CanDriveService } from "./api-handlers/can-drive-handler.service";
import { ExportXLSPDF } from "./commons/export-xls-pdf.service";
import { BusyServices } from "./commons/busy.service";
import { environment } from "../environments/environment";

export function busyConfigFactory() {
  return new BusyConfig({
    message: "Attendere...",
    backdrop: true,
    delay: 0,
  });
}

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment.cookieDomain,
  },
  position: "bottom",
  theme: "classic",
  palette: {
    popup: {
      background: "#cc0000",
      text: "#ffffff",
      link: "#ffffff",
    },
    button: {
      background: "#fefefe",
      text: "#000000",
      border: "transparent",
    },
  },
  type: "info",
  content: {
    message:
      "Roadmap utilizza i cookie per assicurarti la migliore esperienza sul nostro servizio.",
    dismiss: "Fatto!",
    deny: "",
    link: "",
    href: "https://cookiesandyou.com",
    policy: "Cookie Policy",
  },
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NgBusyModule,
    PageNotFoundModule,
    DashboardModule,
    FontAwesomeModule,
    HttpClientModule,
    LoginModule,
    AuthNRoutingModule,
    PaginationModule.forRoot(),
    ButtonsModule.forRoot(),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
    NgcCookieConsentModule.forRoot(cookieConfig),
  ],
  providers: [
    AuthService,
    VehiclesHandlerService,
    ParksHandlerService,
    TravelsHandlerService,
    CanDriveService,
    RefillsHandlerService,
    DateHandlerService,
    SnackBarHandlerService,
    ExportXLSPDF,
    { provide: BusyConfig, useFactory: busyConfigFactory },
    BusyServices,
  ],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
